import React, { createContext } from 'react';

export const FromNotificationsStateContext = createContext();
export const FromNotificationsSetStateContext = createContext();

export const FromNotificationsProvider = ({ children, state, setState }) => {
  return (
    <FromNotificationsStateContext.Provider value={state}>
      <FromNotificationsSetStateContext.Provider value={setState}>
        {children}
      </FromNotificationsSetStateContext.Provider>
    </FromNotificationsStateContext.Provider>
  );
};
